var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.25H2C1.60218 10.25 1.22064 10.092 0.93934 9.81066C0.658035 9.52936 0.5 9.14782 0.5 8.75V2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5H8.75C9.14782 0.5 9.52936 0.658035 9.81066 0.93934C10.092 1.22064 10.25 1.60218 10.25 2V2.75M7.25 5.75H14C14.8284 5.75 15.5 6.42157 15.5 7.25V14C15.5 14.8284 14.8284 15.5 14 15.5H7.25C6.42157 15.5 5.75 14.8284 5.75 14V7.25C5.75 6.42157 6.42157 5.75 7.25 5.75Z",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copy-to-clipboard.f01189f6dd094c9b0f1c8bec97303f4a.svg";
export { ForwardRef as ReactComponent };